// src/admin/screens/dashboard/AlertStrip.tsx
// Compact warning row above the dashboard grid that summarises items needing
// human attention (pending approvals, KYC backlog, PTPs due today, etc.).
// Each item is a link that deep-filters the relevant queue.
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import styles from './AlertStrip.module.css';

interface Alert {
  to: string;
  text: string;
}

interface Props {
  alerts: Alert[];
}

export default function AlertStrip({ alerts }: Props) {
  if (alerts.length === 0) return null;
  return (
    <div className={styles.strip} role="status">
      <AlertTriangle size={16} aria-hidden="true" />
      <div className={styles.list}>
        {alerts.map((a, i) => (
          <Link key={i} to={a.to} className={styles.item}>
            {a.text}
          </Link>
        ))}
      </div>
    </div>
  );
}
